import { TextCell } from "@similarweb/pro-logic-components";

import { CellDefaultTooltip, renderDefaultTextCell } from "app/pages/sales-intelligence/common-components/table-cells";
import { createRegularColumnFactory } from "app/pages/sales-intelligence/modules/apps-search/configuration/columns/utils";
import type { AppsColumnListConfig } from "app/pages/sales-intelligence/modules/apps-search/types/table";
import { createSharedColumnList } from "app/pages/sales-intelligence/pages/find-apps/configuration/columns/sharedColumnList";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { IFindAppsAndroidRowDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

export const androidTableColumnConfig: AppsColumnListConfig<IFindAppsAndroidRowDto> = new Map([
    ...(createSharedColumnList({
        i18nKeyModifier: AppsSourceType.GoogleStore,
    }) as unknown as AppsColumnListConfig<IFindAppsAndroidRowDto>),

    [
        "package_name",
        createRegularColumnFactory({
            dataIndex: "package_name",
            ellipsis: true,
            render: (value: IFindAppsAndroidRowDto["package_name"]) => (
                <CellDefaultTooltip content={value}>
                    <TextCell>{value}</TextCell>
                </CellDefaultTooltip>
            ),
        }),
    ],
    [
        "app_category",
        createRegularColumnFactory({
            dataIndex: "app_category",
            render: (value: IFindAppsAndroidRowDto["app_category"]) => renderDefaultTextCell(value),
        }),
    ],
    [
        "total_downloads",
        createRegularColumnFactory({
            dataIndex: "total_downloads",
            align: "end",
            render: (value: IFindAppsAndroidRowDto["total_downloads"]) => renderDefaultTextCell(value),
        }),
    ],
]);
